module.exports = __webpack_public_path__ + "static/img/home_buffer_bg.c08a8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_buffer_bg.png
// module id = yI4Z
// module chunks = 0